import { useShoppingCartsContext } from 'context/ShoppingCartsContext';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { MenuPlannerItemsBulkResponse } from 'api/menuPlanner/GetMenuPlannerItemsBulk';
import ShoppingCartDetailComponent from 'components/desktop/ShoppingCart/Detail/Index';
import LoadingAnimation from 'components/desktop/_general/Loading/LoadingAnimation';
import { ShoppingCart } from 'types/ShoppingCart/ShoppingCart';

const ShoppingCartDetailContainer = () => {
	const { id } = useParams();

	const carts = useShoppingCartsContext();
	const [cart, setCart] = useState<ShoppingCart.Type | undefined>(undefined);
	const [menuPlansOrders, setMenuPlansOrders] = useState<MenuPlannerItemsBulkResponse[] | null>(
		null
	);

	useEffect(() => {
		if (!id) return;
		const loadCart = async () => {
			const updatedList = await carts.initializeSingleCart(id);
			const updatedCart = updatedList.find((c) => c.id === id);
			setCart(updatedCart);
		};
		loadCart();
	}, [id]);

	useEffect(() => {
		if (!cart) return;
		(async () => {
			const menuPlans = await ShoppingCart.getMenuplanOrdersList(cart);
			setMenuPlansOrders(menuPlans);
		})();
	}, [cart]);

	const refreshMenuPlanOrders = useCallback(() => {
		if (!id) return Promise.resolve();
		return carts.initializeSingleCart(id).then(() => {
			// Wait for cart to update and then fetch menu plans
			const updatedCart = carts.get(id);
			if (!updatedCart) return;
			return ShoppingCart.getMenuplanOrdersList(updatedCart).then((menuPlans) =>
				setMenuPlansOrders(menuPlans)
			);
		});
	}, [id, carts]);

	return (
		<main className="container">
			{cart && menuPlansOrders ? (
				<ShoppingCartDetailComponent
					cart={cart}
					menuPlanOrders={menuPlansOrders}
					refreshMenuPlanOrders={refreshMenuPlanOrders}
				/>
			) : (
				<LoadingAnimation isLoading={!(cart && menuPlansOrders)}></LoadingAnimation>
			)}
		</main>
	);
};

export default ShoppingCartDetailContainer;
